export class Response {
    success: boolean;
    message: string;
    responseData: any[];
    constructor() {
        this.responseData = [];
    }
}
